import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { useUser } from "../../context/UserContext";
import UserDropDown from "../Navigation/userDropDown/UserDropDown";

const Sidebar = () => {
  const { user, handleLogout } = useUser();
  const current_role = user?.role;
  const current_role_key = user?.role_key;
  const location = useLocation();
  const [expandedMenu, setExpandedMenu] = useState("");
  const [activeMenu, setActiveMenu] = useState("");

  useEffect(() => {
    // Check URL path and set the expanded state
    if (location.pathname.indexOf("user_dashboard") !== -1) {
      // setExpandedMenu('companies');
      setActiveMenu("user_dashboard");
    } else if (location.pathname.startsWith("/companies")) {
      // setExpandedMenu('companies');
      setActiveMenu("companies");
    } else if (location.pathname.startsWith("/users")) {
      // setExpandedMenu('users');
      setActiveMenu("users");
    } else if (location.pathname.startsWith("/admin")) {
      setActiveMenu("admin");
    } else if (location.pathname.startsWith("/accounts")) {
      // setExpandedMenu('accounts');
      setActiveMenu("accounts");
    } else if (location.pathname.startsWith("/demo_requests")) {
      // setExpandedMenu('accounts');
      setActiveMenu("demo_requests");
    } else if (location.pathname.startsWith("/user_stats")) {
      // setExpandedMenu('accounts');
      setActiveMenu("user_stats");
    }
  }, [location.pathname]);

  useEffect(() => {
    // Re-render the sidebar when user role changes
    // setExpandedMenu(''); // Reset the expanded menu state on role change
  }, [current_role, current_role_key]);

  if (
    current_role_key === undefined ||
    current_role_key === "CLIENT" ||
    current_role_key === "CLIENT_EMPLOYEE" ||
    current_role_key === "SALES_DEMO"
  ) {
    return <></>;
  }

  return (
    <div
      className="client-layout-main-layout-sidebar"
      style={{ minWidth: "15%", maxWidth: "15%" }}
    >
      <div className="d-flex flex-column align-items-center align-items-sm-start pt-2 text-white min-vh-100">
        <ul className="nav nav-list" id="menu">
          {current_role_key !== "ANALYST" && (
            <li
              className={`${activeMenu === "user_dashboard" || activeMenu === "admin" ? "active" : ""}`}
            >
              <Link className="dropdown-item" to={current_role_key === "SUPER_ADMIN" || parseInt(current_role) === 24 ? "/admin" : "/users/user_dashboard"}>
                <i className="menu-icon fa fa-home font18"></i>
                <span className="ms-1 d-sm-inline">Dashboard</span>
              </Link>
            </li>
          )}

          {current_role_key !== "ACCOUNT_MANAGER" ? (
            current_role_key !== "ACCOUNT_MANAGER" && (
              <>
                {current_role_key !== "ANALYST" &&
                  current_role_key !== "CLIENT" && (
                    <li
                      className={`${activeMenu === "companies" ? "active" : ""
                        }`}
                    >
                      <Link className="dropdown-item" to="/companies">
                        <i className="menu-icon fa fa-university font15"></i>
                        <span className="ms-1 d-sm-inline">
                          Account Management
                        </span>
                      </Link>
                    </li>
                  )}

                {current_role_key !== "ANALYST" &&
                  current_role_key !== "CLIENT" && (
                    <li className={`${activeMenu === "users" ? "active" : ""}`}>
                      <Link className="dropdown-item" to={current_role_key === "SUPER_ADMIN" || parseInt(current_role) === 24 ? "/admin" : "/users"}>
                        <i className="menu-icon fa fa-users font16"></i>
                        <span className="ms-1 d-sm-inline">
                          User Management
                        </span>
                      </Link>
                    </li>
                  )}

                {/* {current_role_key !== 'ANALYST' && (<li className={`${activeMenu === 'accounts' ? 'active' : ''}`} >
        <Link className="dropdown-item" to="/accounts">
          <i className="menu-icon fa fa-file-text font16" aria-hidden="true"></i>
          <span className="ms-1 d-sm-inline">Accounts</span>
        </Link>
      </li>)} */}
                {/* <li className={`${activeMenu === 'demo_requests' ? 'active' : ''}`} >
        <Link className="dropdown-item" to="/demo_requests">
          <i className="menu-icon fa fa-file-text font16" aria-hidden="true"></i>
          <span className="ms-1 d-sm-inline">Demo Requests</span>
        </Link>
      </li> */}
              </>
            )
          ) : (
            <>
              {/* <li className={`${activeMenu === 'user_stats' ? 'active' : ''}`} >
        <Link className="dropdown-item" to="/user_stats/user_stats">
          <i className="menu-icon fa fa-file-text font16" aria-hidden="true"></i>
          <span className="ms-1 d-sm-inline">User Stats</span>
        </Link>
      </li> */}
            </>
          )}

          {/* <li className="initial_block_bottom">
            <UserDropDown
              user={user}
              currentRoleKey={currentRoleKey}
              filteredRoles={filteredRoles}
              configUserRoles={configUserRoles}
              switchUser={switchUser}
              handleLogout={handleLogout}
            />
          </li> */}

          {/*
  current_role_key === 'ACCOUNT_MANAGER' && (
    <li className={`${activeMenu === 'account-manager' ? 'active' : ''}`} >
      <Link className="dropdown-item" to="/account-manager">
        <i className="menu-icon fa fa-user-tie font16"></i>
        <span className="ms-1 d-sm-inline">Account Manager</span>
      </Link>
    </li>
  )*/}
        </ul>
        <hr />
      </div>
    </div>
  );
};

export default Sidebar;
